module.exports = __webpack_public_path__ + "img/flightsite_logo.3d161cb8.png";